export enum Permission {
  CatalogHealthView = 'catalog_health.view',
}
